var PaymentComponentStrings = {
    cardFields: {
        errors: {
            addCard: function () { return 'Please try again later or use another payment method.'; },
            invalidField: function () { return 'Invalid'; },
            requiredField: function () { return 'Required'; },
        },
    },
};
export default PaymentComponentStrings;
